import { ReactNode } from 'react';

import s from '../Stepper.module.scss';

export const Label = ({ stepCount, title }: { stepCount: number; title: ReactNode }) => {
  return (
    <div className="align-items-center flex gap-3.5 py-1.5">
      <div className={s.step_count}>{stepCount}</div>
      <div className={s.title}>{title}</div>
    </div>
  );
};
